module.exports = __webpack_public_path__ + "static/media/USD.44cef35d.svg";